import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2, convertJsonToFieldValueAvro } from 'rpc-client-utils';
import { listVersionsCountedRpc, updateBufferRpc, restoreCombinedVersionToBufferRpc, pushBufferLiveRpc, pushCombinedBufferLiveRpc, hasBufferedChangesRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ThemeSettingsRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
export const DEFAULT_PAGINATION_LIMIT = 15;
export const API_BASE = 'content/themes/v1/settings';
const isUngatedForCHIRP = () => Routes.isUngated(gate('ThemesAndModules:ThemeSettingsChirpMigration'));
export const hasBufferedChanges = id => {
  const HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME = `has-buffered-changes-fetch`;
  const earlyRequest = quickFetch.getRequestStateByName(HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME);
  let resultPromise;
  const hasBufferedChangesApiPath = `${API_BASE}/${id}/has-buffered-changes`;
  const fetchData = () => http.get(hasBufferedChangesApiPath);
  const fetchChirpData = () => rpcClient.call(hasBufferedChangesRpc, {
    request: {
      id
    }
  });
  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError(() => {
        if (isUngatedForCHIRP()) {
          resultPromise = fetchChirpData();
        } else {
          fetchData().then(resolve, reject).catch(err => console.error(err));
        }
        quickFetch.removeEarlyRequest(HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME);
      });
    });
  } else {
    resultPromise = isUngatedForCHIRP() ? fetchChirpData() : fetchData();
  }
  return resultPromise;
};
export const saveBuffer = (id, data) => {
  if (isUngatedForCHIRP()) {
    const CHIRPformattedValues = convertJsonToFieldValueAvro(data.values);
    const CHIRPformattedBreakpointStyles = convertJsonToFieldValueAvro(data.breakpointStyles);
    return rpcClient.call(updateBufferRpc, {
      request: {
        id,
        values: CHIRPformattedValues.value,
        breakpointStyles: CHIRPformattedBreakpointStyles.value
      }
    });
  }
  return http.put(`${API_BASE}/${id}/buffer`, {
    data
  });
};
export const publishBuffer = id => {
  if (isUngatedForCHIRP()) {
    return rpcClient.call(pushBufferLiveRpc, {
      request: {
        id
      }
    });
  }
  return http.post(`${API_BASE}/${id}/push-buffer-live`);
};
export const publishCombinedBuffer = (themeSettingsId, activeThemePresetObjectId) => {
  return rpcClient.call(pushCombinedBufferLiveRpc, {
    request: {
      themeSettingsId,
      activeThemePresetObjectId
    }
  });
};
export const fetchRevisions = (id, data) => {
  if (isUngatedForCHIRP()) {
    return rpcClient.call(listVersionsCountedRpc, {
      request: {
        objectId: id,
        pageLength: DEFAULT_PAGINATION_LIMIT,
        offset: {
          offset: data.offset || 0
        }
      }
    });
  } else {
    return http.get(`${API_BASE}/${id}/versions-counted`, {
      query: Object.assign({}, data, {
        limit: DEFAULT_PAGINATION_LIMIT
      })
    });
  }
};
export const revertThemeSettings = (id, data) => {
  const {
    themePath,
    versionId
  } = data;
  if (isUngatedForCHIRP()) {
    return rpcClient.call(restoreCombinedVersionToBufferRpc, {
      request: {
        modelId: id,
        themePath,
        versionId
      }
    });
  }
  return http.post(`${API_BASE}/${id}/versions/restore-combined-to-buffer`, {
    query: {
      'theme-path': themePath
    },
    data: {
      versionId
    }
  });
};
export const fetchThemeVariant = (pathToTheme, variantName) => http.post(`${API_BASE}/variant/${variantName}/by-path/${pathToTheme}`);